import React, { useContext } from 'react';
import { StyleSheet, TouchableHighlight, View } from 'react-native';

import DyteClient from '@dytesdk/web-core';
import { IconPack, defaultIconPack } from '../lib/icons';
import { States } from '../types/props';
import { DyteI18n, useLanguage } from '../lib/lang';
import DyteText from './DyteText';
import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function ({
  meeting,
  iconPack = defaultIconPack,
  states,
  t,
}: {
  meeting: DyteClient;
  iconPack?: IconPack;
  states?: States;
  t?: DyteI18n;
}) {
  const onStage =
    meeting.stage.status === 'ON_STAGE' ||
    meeting.stage.status === 'ACCEPTED_TO_JOIN_STAGE';
  const defaultLang = useLanguage();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  t = t ?? defaultLang;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  iconPack = iconPack ?? defaultIconPack;
  const { storeStates, setStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  states = states ?? storeStates;
  if (meeting.meta.viewType !== 'LIVESTREAM') {
    setStates({ ...states, activeStageConfirmation: false });
    return null;
  }
  const styles = StyleSheet.create({
    mainContainer: {
      paddingHorizontal: 18,
      borderRadius: 4,
    },
    buttonContainer: {
      paddingTop: 15,
      justifyContent: 'space-between',
      flexDirection: onStage ? 'row' : 'column',
    },
    button: {
      flex: onStage ? 1 : 0,
      marginHorizontal: 4,
      marginBottom: 8,
    },
    buttonText: {
      borderRadius: 4,
      height: 40,
      alignItems: 'center',
      justifyContent: 'center',
      paddingHorizontal: 16,
    },
  });
  if (!meeting.stage) return null;
  return (
    <View style={styles.mainContainer}>
      {/* eslint-disable-next-line react-native/no-inline-styles */}
      <View style={{ paddingTop: 25 }}>
        <DyteText size={'xl'} fontWeight="bold">
          {onStage ? 'Drop' : 'Request'}
        </DyteText>
      </View>
      {/* eslint-disable-next-line react-native/no-inline-styles */}
      <View style={{ paddingVertical: 20 }}>
        <View style={styles.buttonContainer}>
          <TouchableHighlight
            underlayColor={colors.background[800]}
            onPress={() => {
              try {
                onStage
                  ? setStates({ ...states, activeStageConfirmation: false })
                  : meeting.stage.requestAccess();
              } catch (err) {
                console.log(err);
              }
              setStates({ ...states, activeStageConfirmation: false });
            }}
            style={styles.button}
          >
            <View
              style={{
                ...styles.buttonText,
                backgroundColor: onStage
                  ? colors.background[700]
                  : colors.brand[500],
              }}
            >
              <DyteText size="sm">
                {onStage ? 'Cancel' : 'Request to Present'}
              </DyteText>
            </View>
          </TouchableHighlight>
          <TouchableHighlight
            underlayColor={colors.background[800]}
            onPress={() => {
              try {
                onStage
                  ? meeting.stage.leave()
                  : setStates({ ...states, activeStageConfirmation: false });
              } catch (err) {
                console.log(err);
              }
              setStates({ ...states, activeStageConfirmation: false });
            }}
            // eslint-disable-next-line react-native/no-inline-styles
            style={{ flex: onStage ? 1 : 0, marginHorizontal: 4 }}
          >
            <View
              style={{
                ...styles.buttonText,
                backgroundColor: colors.danger,
              }}
            >
              <DyteText size="sm">{onStage ? 'Drop' : 'Cancel'}</DyteText>
            </View>
          </TouchableHighlight>
        </View>
      </View>
    </View>
  );
}
